/** @format */

import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import { KsefErrorDataByDate } from '../../../interfaces/ksef/KsefErrorData';

type KsefErrorDialogType = {
    classes: any;
    dialogOpen: boolean;
    closeCallback: () => void;
    ksefErrorDataByDate: KsefErrorDataByDate;
};

export const KsefErrorDialog = (props: KsefErrorDialogType): React.ReactElement => {
    const classes                                   = props.classes;

    return (
        <>
            <Dialog open={props.dialogOpen} onClose={props.closeCallback} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    <I18n trans={"documents:invoices.ksefErrorParser.ksefErrorDetails"} />
                </DialogTitle>
                <DialogContent style={{minWidth: 550}}>
                    <>
                        {Object.keys(props.ksefErrorDataByDate).map((dateKey: string) => {
                            const errorData = props.ksefErrorDataByDate[dateKey];
                            return (
                                <div key={dateKey} style={{marginBottom: '20px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px'}}>
                                    <h4><I18n trans={"documents:invoices.ksefErrorParser.error_date"}/>: {DateHelperTs.format(dateKey)}</h4>
                                    {errorData.internalError && (
                                        <div>
                                            <h5><I18n trans={"documents:invoices.ksefErrorParser.internal_error"}/>:</h5>
                                            <p><strong><I18n
                                                trans={"documents:invoices.ksefErrorParser.description"}/>:</strong> <I18n trans={'documents:invoices.ksefErrorParser.'+errorData.internalError}/></p>
                                        </div>
                                    )}
                                    {errorData.rejectedInvoice && (
                                        <div style={{marginBottom: '10px'}}>
                                            <h5><I18n trans={"documents:invoices.ksefErrorParser.rejected_invoice"}/>:</h5>
                                            <p><strong><I18n
                                                trans={"documents:invoices.ksefErrorParser.invoice_number"}/>:</strong> {errorData.rejectedInvoice.invoiceNumber}
                                            </p>
                                            {errorData.rejectedInvoice.ksefFailure && (
                                                <div style={{marginLeft: '20px'}}>
                                                    <p><strong><I18n
                                                        trans={"documents:invoices.ksefErrorParser.failure_code"}/>:</strong> {errorData.rejectedInvoice.ksefFailure.code}
                                                    </p>
                                                    <p><strong><I18n
                                                        trans={"documents:invoices.ksefErrorParser.description"}/>:</strong> {errorData.rejectedInvoice.ksefFailure.description}
                                                    </p>
                                                    {errorData.rejectedInvoice.ksefFailure.details && (
                                                        <div>
                                                            <strong><I18n trans={"documents:invoices.ksefErrorParser.details"}/>:</strong>
                                                            <ul>
                                                                {errorData.rejectedInvoice.ksefFailure.details.map((detail, index) => (
                                                                    <li key={index}>{detail}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {errorData.rejectedInvoice.validationFailures && (
                                                <div style={{marginLeft: '20px'}}>
                                                    <strong><I18n trans={"documents:invoices.ksefErrorParser.validation_failures"}/>:</strong>
                                                    <ul>
                                                        {errorData.rejectedInvoice.validationFailures.map((failure, index) => (
                                                            <li key={index}>
                                                                <p><strong><I18n trans={"documents:invoices.ksefErrorParser.field"}/>:</strong> {failure.field}
                                                                </p>
                                                                <p><strong><I18n
                                                                    trans={"documents:invoices.ksefErrorParser.description"}/>:</strong> {failure.description}</p>
                                                                {failure.invalidValue && <p><strong><I18n
                                                                    trans={"documents:invoices.ksefErrorParser.invalid_value"}/>:</strong> {failure.invalidValue}
                                                                </p>}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {errorData.packageError && (
                                        <div>
                                            <h5><I18n trans={"documents:invoices.ksefErrorParser.package_error"}/>:</h5>
                                            <p><strong><I18n trans={"documents:invoices.ksefErrorParser.failure_code"}/>:</strong> {errorData.packageError.code}
                                            </p>
                                            <p><strong><I18n
                                                trans={"documents:invoices.ksefErrorParser.description"}/>:</strong> {errorData.packageError.description}</p>
                                            {errorData.packageError.details && (
                                                <div>
                                                    <strong><I18n trans={"documents:invoices.ksefErrorParser.details"}/>:</strong>
                                                    <ul>
                                                        {errorData.packageError.details.map((detail, index) => (
                                                            <li key={index}>{detail}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );

                        })
                        }
                        </>
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withStyles(oplAppStyle)(KsefErrorDialog);
